import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export const defaults = Object.freeze({
  primary: '#009688',
  primary_inverse: '#FFFFFF',
  secondary: '#6E7FF1',
  success: '#8DDC88',
  info: '#71BAFF',
  danger: '#F8706D',
  warning: '#FFD652',
  accent: '#82B1FF',
  error: '#FF5252',
  itemLabel: '#919191',
  mainTitleLabel: '#32325d',
  disabled: '#bfbdbd',
  green: '#619437',
  muted: '#cccccc',
  lightGreen: '#9CD291',
  greenTextColor: '#4E8939',
});

export default new Vuetify({
  theme: {
    options: { customProperties: true },
    themes: {
      light: { ...defaults },
    },
  },
});
